<template>
    <div class="row justify-content-center">
        <transition name="fade" mode="out-in">
            <AppPlaceholder class="col-xl-8" v-if="!vessel" key="no-product-package"/>
            <div v-else class="col-xl-8" key="product-package">
                <div class="row">
                    <div class="col-12 mb-4 d-sm-flex justify-content-between align-items-baseline">
                        <div class="pl-3">
                            <h4>
                                {{ isNew
                                ? 'New vessel'
                                : vessel.name }}
                            </h4>
                            <p class="mb-0 text-muted" v-if="!isNew">
                                <small>Created on {{ vessel.created_at | date }}</small>
                            </p>
                        </div>
                        <div class="col-12 col-sm-auto text-right pr-0 mt-2 mt-sm-0">
                            <button class="btn btn-primary mr-2"
                                    :disabled="loading"
                                    @click="save">
                                Save
                            </button>
                            <button class="btn btn-outline-secondary"
                                    :disabled="loading"
                                    @click="saveAndClose">
                                Save & close
                            </button>
                            <b-dropdown variant="link"
                                        no-caret
                                        right
                                        v-if="!isNew">
                                <template v-slot:button-content>
                                    <i class="material-icons">more_vert</i>
                                </template>
                                <b-dropdown-item :disabled="loading"
                                                 @click="destroy">
                                    Delete
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <AppInput label="Name"
                                      :value="vessel.name"
                                      field="name"
                                      :errors="errors"
                                      @change="updateVesselProps({ name: $event })"
                                      class="col-md-6"/>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import NotificationService from '../../services/notification.service';
import AppInput from '../form/AppInput';
import AppPlaceholder from '../form/AppPlaceholder';
import Errors from '../../utils/errors';
import { formatDate } from '../../filters/date.filter';

export default {
  components: {
    AppInput,
    AppPlaceholder,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      canClose: false,
    };
  },

  filters: {
    date: formatDate,
  },
  computed: {
    ...mapGetters({
      vessel: 'vessels/vessel',
    }),
    isNew() {
      return this.$route.params.id === 'new';
    },
  },
  mounted() {
    this.initVessel();
  },
  watch: {
    '$route.params.id'() {
      this.initVessel();
    },
  },
  methods: {
    initVessel() {
      return this.isNew
        ? this.$store.dispatch('vessels/newVessel')
        : this.getVessel();
    },
    getVessel() {
      this.$store.dispatch('vessels/getVessel', this.$route.params.id);
    },
    updateVesselProps(props) {
      this.$store.dispatch('vessels/updateVesselProps', props);
    },
    saveAndClose() {
      this.save()
        .then(() => {
          if (this.canClose) {
            this.$router.push({ name: 'vessels' });
          }
        });
    },
    save() {
      this.loading = true;
      this.errors.clear();
      return this.$store.dispatch(this.isNew ? 'vessels/createVessel' : 'vessels/updateVessel')
        .then((res) => {
          this.canClose = true;
          if (this.isNew) {
            this.$router.push({
              name: 'vessel',
              params: { id: res.vessel_id },
            });
          }
          NotificationService.success(res.message);
        })
        .catch((err) => {
          this.canClose = false;
          this.errors.set(err.response.data.errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    destroy() {
      this.$bvModal.msgBoxConfirm('Delete vessel?', {
        okTitle: 'Delete',
        okVariant: 'danger',
      })
        .then((value) => {
          if (value) {
            this.$store.dispatch('vessels/deleteVessel')
              .then((res) => {
                NotificationService.success(res.message);
                this.$router.push({ name: 'vessels' });
              });
          }
        });
    },
  },
};
</script>
